@import "../../../globalStyles/commons";


$border-width: 0.125;


:host {
  display: inline-block;
}

.tab {
  position: relative;
  display: flex;
  align-items: center;
  height: 2.5rem;

  .native-button {
    height: 100%;
    background: transparent;
    cursor: pointer;
    color: v(--text-secondary);
    z-index: v(--z-index-button);
    padding: 0;
    border: none;
    outline: none;
    text-decoration: none;

    .slot-container {
      display: flex;
    }

    .tab-content {
      display: flex;
      align-items: center;
      flex-direction: row;
      height: 100%;
      gap: v(--spacing-02);
      padding: 0 1rem;
      @include font-style(body-compact-01);
    }
  }

  .tab-background {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }


  &:hover {
    .native-button {
      color: v(--text-primary);
      border-bottom-color: var(--border-strong);
    }
  }

  &.disabled {
    .native-button {
      cursor: not-allowed;
      color: v(--text-disabled);
    }
  }

  &:not(.has-content) .slot-container {
    display: none;
  }

  &.selected {
    .native-button {
      color: v(--text-primary);
    }

    .tab-content {
      @include font-style(heading-compact-01);
    }
  }

}

/**
 * Tab variant definitions - bottom line
 */
.tab.type-default {

  .native-button {
    border-bottom: 2px solid var(--border-subtle);

    .tab-content {
      border: 2px solid transparent;
      border-bottom: 0;
    }
  }

  .tab-background {
    background: transparent;
  }


  &.selected {
    .native-button {
      border-bottom-color: v(--border-interactive);
    }
  }


  &.has-focus:not(.active) {
    .native-button {
      border-bottom-color: v(--border-interactive);
    }

    .tab-content {
      border-color: v(--border-interactive);
    }
  }

  &.disabled {
    .native-button {
      border-bottom-color: v(--border-disabled) !important;
    }

    &.has-focus:not(.active) .tab-content {
      border-color: transparent !important;
    }
  }
}

.tab.type-contained {

  .native-button {
    border-right: 1px solid var(--border-strong);
    border-top: 2px solid transparent;

    .tab-content {
      border: 2px solid transparent;
      border-top: 0;
    }
  }

  .tab-background {
    background: var(--layer-accent);
  }

  &.selected {
    .native-button {
      border-right-color: transparent;
      border-top-color: var(--border-interactive);
    }

    .tab-background {
      background: var(--layer);
    }
  }

  &.has-focus:not(.active) {
    .native-button {
      border-top-color: var(--border-interactive);
    }

    .tab-content {
      border-color: var(--border-interactive);
    }
  }

  &.disabled {
    .tab-background {
      background: var(--button-disabled) !important;
    }
  }

}

.tab.type-contained-bottom {

  .native-button {
    border-right: 1px solid var(--border-strong);
    border-bottom: 2px solid transparent;

    .tab-content {
      border: 2px solid transparent;
      border-bottom: 0;
    }
  }

  .tab-background {
    background: var(--layer-accent);
  }

  &.selected {
    .native-button {
      border-right-color: transparent;
      border-bottom-color: var(--border-interactive);
    }

    .tab-background {
      background: var(--layer);
    }
  }

  &.has-focus:not(.active) {
    .native-button {
      border-bottom-color: var(--border-interactive);
    }

    .tab-content {
      border-color: var(--border-interactive);
    }
  }

  &.disabled {
    .tab-background {
      background: var(--button-disabled) !important;
    }
  }

}

:host(.last-tab), :host(.previous-tab) {
  .tab.type-contained, .tab.type-contained-bottom {
    .native-button {
      border-right: 0;
    }
  }

  /**
    * Color Variants
    */
  @each $color in [primary, secondary, success, error, info, warning, brand-primary, brand-secondary, custom-01, custom-02, custom-03] {
    :host(.color-#{$color}) .tab {
      --tab-color: #{v(--color-#{$color})};
    }
  }
}

